<template>
    <ss-modal
            v-show="modal"
            title="Title"
            v-if="bailiff"
            intro="bounceIn"
            outro ="bounceOut">
        <!-- HEADER -->
        <div slot = "modal-header">
            Komornik <span class="text-primary">{{ bailiff.name }} {{ bailiff.surname }}</span>
        </div>
        <!-- BODY -->
        <div slot = "modal-body" class="text-center">
            <d-row>
                <d-col xs="5" class="text-right"><strong>Imię i nazwisko</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ bailiff.name }} {{ bailiff.surname }}</d-col>
            </d-row>
            <hr>
            <d-row>
                <d-col xs="5" class="text-right"><strong>Nr telefonu</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left" v-if="bailiff.phone">{{ bailiff.phone ? bailiff.phone : '-' }}</d-col>
                <d-col xs="5" offset-xs="6" class="text-left" v-else>{{ bailiff.phone_number ? bailiff.phone_number : '-' }}</d-col>
            </d-row>
            <d-row v-if="bailiff.telephones.length > 0" v-for="(telephone, index) in bailiff.telephones" :key="index">
                <d-col xs="5" class="text-right"></d-col>
                <d-col xs="5" offset-xs="6" class="text-left"><a :href="'tel:' + telephone.phone_number">
                    {{ telephone.phone_number }}
                </a><br/>{{ telephone.description }}</d-col>
            </d-row>
            <hr>
            <d-row>
                <d-col xs="5" class="text-right"><strong>Adres e-mail</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ bailiff.email ? bailiff.email : '-' }}</d-col>
            </d-row>
            <hr>
            <d-row>
                <d-col xs="5" class="text-right"><strong>Sąd właściwy</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ bailiff.court_name ? bailiff.court_name : '-' }}</d-col>
            </d-row>
            <h2 class="modal-table-separator">Adres kancelarii komorniczej</h2>
            <d-row>
                <d-col xs="5" class="text-right"><strong>Nazwa kancelarii</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ bailiff.bailiff_office_name }}</d-col>
            </d-row>
            <hr>
            <d-row>
                <d-col xs="5" class="text-right"><strong>Adres kancelarii</strong></d-col>
                <d-col xs="5" offset-xs="6" class="text-left">{{ bailiff.bailiff_office_address + ' ' + bailiff.bailiff_office_house_number + (bailiff.bailiff_office_flat_number ? '/' + bailiff.bailiff_office_flat_number : '') + ' ' + bailiff.bailiff_office_post_code + ' ' +  bailiff.bailiff_office_city}}</d-col>
            </d-row>

        </div>
        <!-- FOOTER -->
        <div slot = "modal-footer">
            <d-button @click.prevent="$emit('update:show', false)" theme="danger">Zamknij</d-button>
        </div>
    </ss-modal>
</template>

<script>
  import SsModal from '../common/SsModal'
  export default {
    name: "BailiffModal",
    components: {
      SsModal
    },
    props: {
      props: {
        type: Object,
        default: ()=> {}
      },
      show: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
        bailiff: null,
        modal: false,
        uid: null
      }
    },
    mounted(){
      this.modal = this.show;
      this.bailiff = this.props;
      this.uid = this._uid;
    },
    methods: {
      toNumber(number){
        return Vue.toNumber(number);
      }
    },
    watch: {
      props: {
        handler: function(to) {
          this.bailiff = to;
        },
        deep: true
      },
      show(to) {
        this.modal = to;
      },
    }
  }
</script>

<style scoped>

</style>
